<template>
  <div id="pagePerfisAcesso">
    <v-container grid-list-x2 fluid>
      <v-layout row wrap justify-center>
        <v-flex lg8 sm12 xs12>
          <v-card>
            <v-toolbar color="pink" dark flat dense cad>
              <v-toolbar-title class="subheading">Visualizar perfil</v-toolbar-title>
              <v-spacer></v-spacer>
              <router-link :to="{ name: 'PerfisAcesso' }" class="nounderline">
                <v-btn outline>Voltar</v-btn>
              </router-link>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="">
              <perfil-form></perfil-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import PerfilForm from "@/components/perfisAcesso/visualizarPerfilAcesso"
export default {
  components: {
    PerfilForm
  },
  data: () => ({
    id: null
  }),
  created() {
    if (this.$route && this.$route.params) {
      this.id = this.$route.params.id
    }
  }
}
</script>
